import styled from "styled-components";

export const DesignFutureWrapper = styled.div`
  .design_future_card {
    padding: 80px 15px;
    min-height: 351px;
    position: relative;
    border-radius: 25px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 1199px) {
      min-height: auto;
    }
    @media (max-width: 899px) {
      border-radius: 10px;
      padding: 50px 15px;
    }

    &::before {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      background: rgba(0, 0, 0, 0.7);
      z-index: 1;
    }
    figure {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .design_heading {
      position: relative;
      z-index: 2;
      max-width: 360px;
      margin: 0 auto;
      color: rgb(255, 255, 255);
      text-align: center;
      @media (max-width: 599px) {
        max-width: 100%;
      }
      h2 {
        color: rgb(255, 255, 255);
        text-transform: capitalize;
        margin-bottom: 35px;
        @media (max-width: 1199px) {
          margin: 0 auto 20px;
        }
      }
      button {
        margin: auto;
      }
    }
  }
`;
